export function team() {
    let $btnTeam = $('.btn-team');

    if ($btnTeam.length) {
        $btnTeam.on('click', function (e) {
            e.preventDefault();

            $(this).toggleClass('opened').find('span').text(function(i, text){
                return text === "See all team members" ? "Hide all team members" : "See all team members";
            });

            $('.holder-team').slideToggle();
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/team.js